import "./Splash.scss";

const Splash = <div id='Splash'></div>;

export default Splash;
